/**
 * Paso3.js */

//Dependencies
import React, { Component, createRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux'
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';
import Camara from './NuevaCamara';
import { vuReintentos } from '../../actions/actions';
import { storeUrlRiesgoNet } from './services/riesgoNetService';
import { setErrorMessage } from '../../actions/actions';
import { IndicacionCamara } from './customModals/IndicacionCamara';
import { Layout } from './layout/Layout';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import dorso from '../../static/img/dorso.png';

//Services
import { processToken } from './services/tokenService';
import { processFlow } from './services/flowService';
import { processIdClientAnalytics } from './services/pixelService';


class Paso3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 3,
            disabled : false,
        }

        this.paso3 = this.paso3.bind(this);
        this.camaraRef = createRef();
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
        this.backOperationVU = this.backOperationVU.bind(this);
    }

    componentWillMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('paso-3')
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    paso3() {
        this.setState({disabled : true})
        //Exito, continuar al paso 4 (que no exite)
        processIdClientAnalytics('paso-4')
        //Manejo imperativo del hijo
        //Necesitamos que este scope de ejecución del onClick() se propague para poder abrir la camara.
        this.camaraRef.current.handleClick();
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
    }

    backOperationVU(image) {
        const backOperation = {
            analyzeAnomalies: true,
            analyzeOcr: true,
        };
        let formData = new FormData();
        formData.append("file", image);
        formData.append('data', new Blob([JSON.stringify(backOperation)], {
            type: "application/json"
        }));

        $(".load").fadeIn(700);
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data: formData,
            url:  localStorage.getItem('url') + '/api/vu/backOperation'
        }).then(response => {
            if (response.data.code === "912") {
                this.setSiguientePaso(); 
                this.props.dispatch(
                    vuReintentos(0)
                );
                return this.props.history.push('/paso-5')
            // Nuevo If de validacion imagen horiontal
            } else if (response.data.code === "400") {
                console.error(response.data.message)
                //Mostrar mensaje de error

            } else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone' ) {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/sin-reintentos')
                });
            }else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone' ) {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });
            }
        }).catch(error => {
            if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-servicio')
                });
            }else  if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });
            }
            else {
                this.props.dispatch(
                    setErrorMessage(error.response.data.message)
                );
                if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/sin-reintentos')
                    });
                }else if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                } else  if (error.response.data.message == null) {
                    if(sessionStorage.getItem('tipoFlujo') != 'standalone')
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                    else if(sessionStorage.getItem('tipoFlujo') == 'standalone')
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                } else {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-validacion-imagen')
                    });
                }
            }
        })
    }

    render() {
        const header = {
            progress : {value : 50}
        };
        const footer = {
            button: {
                action : this.paso3,
                text : "escanear dorso",
                disabled: this.state.disabled
            }
        };
        const body = {
            img : {
                src : dorso
            },
            slot : <IndicacionCamara/>
        }
        return (
            <Layout header={header} footer={footer} body={body}
                tieneFooter>
                <Grid item xs={12}>
                    <div className="content-description">
                        <h5 className="title" >Ubica el dorso de tu DNI</h5>
                        <h5 className="title">centrado frente a la cámara</h5>
                        <h6 className="description">Asegurate de que haya suficiente luz y que los datos sean legibles.</h6>
                    </div>
                </Grid>
                <Camara ref={this.camaraRef} parentHandleImage={this.backOperationVU} capture='user'/>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        reintentosVU: state.reintentosVU
    }
}

export default connect(mapStateToProps)(Paso3);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso3.js